import { RouteRecordRaw } from 'vue-router';

const CLUSTER_ROUTES: Array<RouteRecordRaw> = [
   {
      path: '',
      name: 'ClustersOverview',
      component: () => import('@/modules/clusters/pages/ClustersOverview.vue'),
   },
];

export default CLUSTER_ROUTES;
